define('home/views/ProfileCoverView',[
    'jquery',
    'backbone-marionette',

    'home/utils/confirmModal',
    'home/mixins/withAllstarPopover',
    'home/mixins/withTruncate',
    'home/models/Session',
    'home/templates/profileCover',
    'home/templates/spinnerTall',
    'home/templates/reportUser',
    'home/templates/completeReportUser',
], function (
    $,
    Marionette,

    confirmModal,
    withAllstarPopover,
    withTruncate,
    Session,
    profileCoverTemplate,
    spinnerTallTemplate,
    reportUserModalTemplate,
    completeReportUserModalTemplate
) {
    'use strict';

    var ProfileCoverView = Marionette.ItemView.extend({
        template: function (data) {
            // Fetching
            if (!data.name)
                return spinnerTallTemplate(data);

            return profileCoverTemplate(data);
        },
        templateHelpers: function () {
            var sessionUser = Session.get().user;

            var helpers = {
                sessionUserName: sessionUser.get('username'),
                isSessionUser: this.model.isSessionUser(),
                isGlobalAdmin: sessionUser.isGlobalAdmin(),
                numTotalFollowing: this.model.getNumTotalFollowing(),
                showNumPosts: this.model.has('numPosts'),
                showNumFollowers: this.model.has('numFollowers'),
                userReputationLabel: this.model.getUserReputationLabel(),
                numLines: 3,
                showNumTotalFollowing: this.model.has('numFollowing') && this.model.has('numForumsFollowing'),
            };

            if (this.model.get('isBlocked'))
                helpers.avatar = this.model.defaults.avatar;

            return helpers;
        },

        events: {
            'click [data-action=toggle-follow]': 'toggleFollow',
            'click [data-action=block-user]': 'blockUser',
            'click [data-action=prompt-report-user]': 'promptReportUser',
        },
        modelEvents: {
            'change:name': 'render',
            'change:isBlocked': 'render',
            'change:isFlagged': 'render',
            'change:isFollowing': 'handleFollowedClass',
            'change:numFollowers': 'updateNumFollowers',
            'change:numFollowing': 'updateNumFollowing',
            'change:numForumsFollowing': 'updateNumFollowing',
            'change:numChannelsFollowing': 'updateNumFollowing',
        },

        handleFollowedClass: function () {
            this.$('[data-action=toggle-follow]').toggleClass('active', this.model.get('isFollowing'));
        },

        updateNumFollowers: function () {
            this.$('[data-role=num-followers]').text(this.model.get('numFollowers'));
        },

        updateNumFollowing: function () {
            this.$('[data-role=num-following]').text(this.model.getNumTotalFollowing());
        },

        toggleFollow: function (evt) {
            if (evt)
                evt.preventDefault();

            this.model.toggleFollowed();
        },

        promptReportUser: function (evt) {
            if (evt)
                evt.preventDefault();

            confirmModal.confirmationPromise(
                confirmModal.TYPES.CONFIRM_CANCEL,
                reportUserModalTemplate({ user: this.model.get('username') })
            ).then(function (shouldReport, $modal) {
                if (shouldReport)
                    this.reportUser($modal.find('input[name=reason]:checked').val());
            }.bind(this));
        },

        reportUser: function (reason) {
            this.model.report(reason)
                .success(confirmModal.confirmationPromise.bind(
                    this,
                    confirmModal.TYPES.CLOSE,
                    completeReportUserModalTemplate()
                ))
                .fail(this.model.trigger.bind(this.model, 'reportError'));
        },

        blockUser: function (evt) {
            if (evt)
                evt.preventDefault();

            var model = this.model;
            model.block().fail(model.trigger.bind(model, 'blockError'));
        },

        onDomRefresh: function () {
            $('.tooltipped').tooltip();
        },
    });

    withTruncate.call(ProfileCoverView.prototype);
    withAllstarPopover.call(ProfileCoverView.prototype);

    return ProfileCoverView;
});

